import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "./components/Header";
import Footer from "./components/Footer";
import LeadModal from "./components/LeadModal";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Product from "./pages/Product";
import Pricing from "./pages/Pricing";
import Courses from "./pages/Courses";
import Consult from "./pages/Consult";
import AgentPage from "./pages/AgentPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

import { AuthProvider } from "./contexts/AuthContext";
import { SiteProvider } from "./contexts/SiteContext";

const PublicShell = () => {
  const [leadOpen, setLeadOpen] = useState(false);
  const navigate = useNavigate();

  const openLead = () => setLeadOpen(true);
  const closeLead = () => setLeadOpen(false);

  return (
    <div className="min-h-screen text-white">
      <Header onOpenLead={openLead} />
      <main className="pt-0">
        <Routes>
          <Route path="/" element={<Home onOpenLead={openLead} />} />
          <Route path="/product" element={<Product onOpenLead={openLead} />} />
          <Route path="/pricing" element={<Pricing onOpenLead={openLead} />} />
          <Route path="/courses" element={<Courses onOpenLead={openLead} />} />
          <Route path="/agent" element={<AgentPage onOpenLead={openLead} />} />
          <Route path="/consult" element={<Consult />} />
        </Routes>
      </main>
      <Footer />
      <LeadModal
        open={leadOpen}
        onClose={closeLead}
        redirectAfter="/product"
        navigate={navigate}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="/*" element={<PublicShell />} />
            </Routes>
            <Toaster
              theme="dark"
              position="top-center"
              toastOptions={{
                style: {
                  background: "#0A0A10",
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "#fff",
                },
              }}
            />
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
